import React from "react"
import { Wrapper, HeroImageWrapper } from "./styles"
import HeroImage from "../../images/hero.png"

export function Hero() {
  return (
    <Wrapper>
      <h2>
        We are because SHE is… the SHEROES community keeps the love flowing!
        Well wishes, letters, poems, testimonials and more - all brimming with
        kindness, love and togetherness. 💌
      </h2>
      <HeroImageWrapper>
        <img src={HeroImage} alt="Hero" />
      </HeroImageWrapper>
      <h2>
        This is what keeps us going - to do more, to build better - for this
        wonderful community of women taking charge! ❤️
      </h2>
    </Wrapper>
  )
}
